import axios from 'axios-observable';
import { ErrorMsg } from './models/Error';
import { handleResponseError, handleResponseErrorWithoutSSO } from './api.domain';
import { buildAuthHeader } from '../redux/auth/auth.functions';
import { getSSOLoginFlag } from '../containers/Page/sign/signin.domain';
import { AxiosError } from 'axios';

axios.interceptors.request.use(
  config => {
    const link = config?.url as string;
    const token = localStorage.getItem('striderToken');
    if (token && !(config.headers && config.headers['X-Auth-Token'])) {
      const headers: Record<string, string> = {
        ...config.headers,
        Authorization: buildAuthHeader(link, JSON.parse(token).access_token)
      };
      const existingAcceptLanguage = config.headers?.['Accept-Language'];
      if (existingAcceptLanguage === undefined) {
        headers['Accept-Language'] = 'pt-BR';
      }

      return {
        ...config,
        headers
      };
    }
    return config;
  },
  err => {
    return Promise.reject(err);
  }
);

// Try to refresh the token whenever a request is unauthorized
const WITHOUT_STATUS_CODE = 441;

axios.interceptors.response.use(
  response => response,
  (err: AxiosError) => {
    const { response, message } = err;
    const { error, details } = response?.data || {};
    const data = response?.data || {};
    const status = response ? response.status : WITHOUT_STATUS_CODE;

    const errorMsg: ErrorMsg = {
      status,
      message: message || error || details || data.error_description,
      response: err.response
    };

    const isUsingNewSSOLogin = getSSOLoginFlag();

    return isUsingNewSSOLogin ? handleResponseError(err, errorMsg) : handleResponseErrorWithoutSSO({ error: err, status, errorMsg });
  }
);

(window as any).axios = axios;
